var state = {
  example: {}
};
var mutations = {
  set_example: function set_example(state, example) {
    state.example = example;
  }
};
var actions = {
  exampleAction: function exampleAction(_ref, example) {
    var commit = _ref.commit;
    commit('set_test', example);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};